import { render, staticRenderFns } from "./receiptoptions.vue?vue&type=template&id=56b789fa&"
import script from "./receiptoptions.vue?vue&type=script&lang=js&"
export * from "./receiptoptions.vue?vue&type=script&lang=js&"
import style0 from "./receiptoptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports